export const GET_PLANS = 'GET_PLANS';
export const GET_ACTIVE_PLANE = 'GET_ACTIVE_PLANE';
export const CANCEL_SUB = 'CANCEL_SUB';
export const GET_SUB_STATUS = 'GET_SUB_STATUS';
export const CHARGEBEE_CUSTOMER = 'CHARGEBEE_CUSTOMER';
